import React from "react"
import styled, {css} from "styled-components"

import tracking from "@irati-tracking/perks/perks"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import FavouriteButton, {FavouriteButtonWithIconProps, FavouriteButtonOnChange} from "../../Favourite/ButtonWithIcon"
import DEAL_PAGES from "../../../constants/dealPage"

const SFB = styled(FavouriteButton)`
  ${({theme}) => css`
    display: none;
    ${theme.mediaQueries.minWidthMedia.desktop`
      display: block;
      margin: ${theme.spacing.four} auto 0;
    `}
  `}
`

interface Props extends Omit<FavouriteButtonWithIconProps, "onChange">, WithPerkOrReward {}

const StyledFavouriteButton: React.FC<Props> = (props) => {
  if (props.isRewards) {
    return null
  }
  const onChange: FavouriteButtonOnChange = (isFavourite, deal) =>
    isFavourite ? tracking.favouritePerk(deal, DEAL_PAGES.PERK) : tracking.unfavouritePerk(deal, DEAL_PAGES.PERK)
  return <SFB {...props} onChange={onChange} />
}

export default withPerkOrReward(StyledFavouriteButton)
